import { Row, Col, Typography, Input, Form, message } from "antd";
import { useTranslation } from "react-i18next";
import { PlusCircleOutlined } from "@ant-design/icons";
import { setTeamLogins } from "shared/service/StrmService";
import { Member } from "shared/interfaces/Member";

const FormMember: React.FC<any> = (props) => {
  const { team, onNext } = props;
  const { t } = useTranslation("radar");
  const [form] = Form.useForm();

  const onFinish = async () => {
    const { userTeam } = form.getFieldsValue(true);
    const { id } = team;

    const validateUserEmailRegex = (emails: string[]) => {
      const regex =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const isValid = emails.every((email) => regex.test(email));
      return isValid;
    };

    const filteredUserTeam = userTeam.filter(
      (member: Member) => member?.user?.login
    );
    if (
      validateUserEmailRegex(
        filteredUserTeam.map((member: Member) => member?.user?.login)
      )
    ) {
      await setTeamLogins(
        filteredUserTeam.map((member: Member) => ({ ...member, teamId: id }))
      );
      onNext();
    } else message.error(t("pages.TeamStart.invalidMail"));
  };

  return (
    <Form
      layout="vertical"
      form={form}
      onFinish={onFinish}
      initialValues={team}
    >
      <Row>
        <Col xs={24}>
          <Typography.Title style={{ fontSize: 50 }}>
            {t("pages.TeamStart.whatUsers")}
          </Typography.Title>
        </Col>
        <Col xs={24}>
          <Typography.Title
            style={{ color: "#949494", fontSize: 25, marginBottom: 36 }}
          >
            {t("pages.TeamStart.accountLimit", {
              licenseAmount: team.licenseAmount,
            })}
          </Typography.Title>
        </Col>
        <Col xs={24}>
          <Row>
            <Col xs={24}>
              <Form.List name="userTeam">
                {(fields, { add }) => (
                  <div>
                    {fields.map((field, index) => (
                      <Form.Item name={[field.name, "user", "login"]}>
                        <Input disabled={index === 0} />
                      </Form.Item>
                    ))}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "end",
                        color: "#fff",
                      }}
                    >
                      <span
                        style={{
                          fontSize: 24,
                          textTransform: "uppercase",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          if (fields.length < team.licenseAmount)
                            add({ user: { login: "" } });
                        }}
                      >
                        <PlusCircleOutlined /> {t("pages.TeamStart.include")}
                      </span>
                    </div>
                  </div>
                )}
              </Form.List>
            </Col>
            <Col xs={12}>
              <button
                style={{ margin: "32px 0", color: "#fff" }}
                className="border-vazado-colorido"
              >
                {t("pages.TeamStart.skip")}
              </button>
            </Col>
            <Col xs={12} style={{ color: "#fff", textAlign: "end" }}>
              <button
                style={{ margin: "32px 0" }}
                className="border-preenchido-colorido"
              >
                {t("pages.TeamStart.next")}
              </button>
            </Col>
          </Row>
        </Col>
      </Row>
    </Form>
  );
};

export default FormMember;
